export default class TimeclockApi {
  constructor({ httpGet, httpPost, httpPut, httpDelete }) {
    this.httpGet = httpGet;
    this.httpPost = httpPost;
    this.httpPut = httpPut;
    this.httpDelete = httpDelete;
  }

  addTimeclockNote(shiftId, params, httpConfig) {
    return this.httpPut(`timeclock/${shiftId}/notes`, params, httpConfig);
  }
}
